module.exports = __webpack_public_path__ + "static/img/svaneti.0bda093.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/svaneti.jpg
// module id = dzb9
// module chunks = 1